// Google Doc where we document this stuff for all MikMak team members to see.
// https://docs.google.com/spreadsheets/d/1OV3xqG3cUMRw2Y70ugIBldchXTLqiyYKvwT_hK21kyY/

export default {
  'pageView': 'PAGE_VIEW',
  'getFromFirebaseServiceError': 'GET_FROM_FIREBASE_SERVICE_ERROR',

  'dashboardReportCreated': 'DASHBOARD_REPORT_PERMALINK_CREATED',
  'dashboardReportRequested': 'DASHBOARD_REPORT_PERMALINK_REQUESTED',
  'dashboardReportLoaded': 'DASHBOARD_REPORT_PERMALINK_LOADED',
  'dashboardReportScheduled': 'DASHBOARD_REPORT_SCHEDULED',
  'dashboardReportSaved': 'DASHBOARD_REPORT_SAVED',

  'dashboardViewChanged': 'DASHBOARD_VIEW_CHANGED',
  'dashboardRequest': 'DASHBOARD_REQUEST',
  'dashboardRequestResponse': 'DASHBOARD_REQUEST_RESPONSE',
  'dashboardCSVDownloaded': 'DASHBOARD_CSV_DOWNLOADED',
  'dashboardZIPDownloaded': 'DASHBOARD_ZIP_DOWNLOADED',
  'dashboardPreMadeReportSelected': 'DASHBOARD_PREMADE_REPORT_SELECTED',
  'dashboardLinechartToggled': 'DASHBOARD_LINECHART_TOGGLED',
  'dashboardMetricsChanged': 'DASHBOARD_METRICS_CHANGED',
  'dashboardDimensionsChanged': 'DASHBOARD_DIMENSIONS_CHANGED',
  'dashboardGlossaryDownloaded': 'DASHBOARD_GLOSSARY_DOWNLOADED',
  'dashboardBenchmarksViewSelected': 'DASHBOARD_BENCHMARKS_VIEW_SELECTED',
  'dashboardBenchmarksQuarterSelected': 'DASHBOARD_BENCHMARKS_QUARTER_SELECTED',
  'dashboardBenchmarksDimensionExpanded': 'DASHBOARD_BENCHMARKS_DIMENSION_EXPANDED',

  'createReportFooterButtonClicked': 'CREATE_REPORT_FOOTER_BUTTON_CLICKED',
  'dataTileButtonClick': 'DATA_TILE_BUTTON_CLICK',
  'dataTileLinkClick': 'DATA_TILE_LINK_CLICK',

  'onboardingSkipped': 'ONBOARDING_SKIPPED',
  'onboardingFinished': 'ONBOARDING_FINISHED',
  'onboardingStarted': 'ONBOARDING_STARTED',

  // marketing widget events
  'marketingWidgetLoadStarted': 'MARKETING_WIDGET_LOAD_STARTED',
  'marketingWidgetInitialized': 'MARKETING_WIDGET_INITIALIZED',
  'marketingWidgetLoadError': 'MARKETING_WIDGET_LOAD_ERROR',
};
